import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { ConstructionIcon } from 'lucide-react'

export const Route = createFileRoute('/_app/settings/app-builder')({
	component: SettingsAppBuilderPage,
})

function SettingsAppBuilderPage() {
	const { t } = useTranslation()
	return (
		<div className="flex h-full flex-col items-center justify-center gap-3 px-4 py-12 text-center">
			<ConstructionIcon className="size-10 text-(--color-muted-foreground)" />
			<h2 className="text-base font-[500]">{t('settings.appBuilder.comingSoon')}</h2>
			<p className="max-w-md text-sm text-(--color-muted-foreground)">
				{t('settings.appBuilder.description')}
			</p>
		</div>
	)
}
